'use strict';

/**
 * Displays all the potential payment methods (with a disclaimer) as per legislation demands.
 */
customerZone.component('beforehandPaymentMethods', {
    templateUrl:
        customerZone.fromBase('components/beforehand-payment-methods/beforehand-payment-methods.component.html'),
    controller: function(){}
});
